import { IS_MOBILE } from '@repo/common-utils';
import cn from 'clsx';
import { useRef } from 'react';

import { PreviewZoomController } from '@/components/tax-refund/power-of-attorney/PreviewZoomController.tsx';
import { A4_HEIGHT, A4_WIDTH } from '@/lib/constants/pdf.ts';
import { useDocumentElementZoom } from '@/lib/hooks/use-document-element-zoom.ts';

export const PoaPreview = ({ documentHtml, isAllowZoom = true }: { isAllowZoom?: boolean; documentHtml: string }) => {
  const {
    previewContainerRef,
    previewScale,
    zoomScale,
    zoomedWidth,
    zoomedHeight,
    isMaxZoom,
    isMinZoom,
    pointerCount,
    interactionHandlers,
    handleZoomOut,
    handleZoomIn,
    handleResetZoom
  } = useDocumentElementZoom({ isAllowZoom: isAllowZoom });
  const frozenIsMinZoomRef = useRef(isMinZoom);

  if (pointerCount !== 2) {
    frozenIsMinZoomRef.current = isMinZoom;
  }

  const stableIsMinZoom = pointerCount === 2 ? frozenIsMinZoomRef.current : isMinZoom;

  return (
    <>
      <div
        className={cn('relative w-fit h-full max-w-full max-h-full', {
          'min-h-0': isAllowZoom
        })}
        style={isAllowZoom ? undefined : { aspectRatio: `${A4_WIDTH} / ${A4_HEIGHT}` }}
      >
        <div
          key={'preview-container'}
          ref={previewContainerRef}
          className={cn({
            'overflow-auto overscroll-contain h-fit w-full max-h-full elevation-small [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden':
              isAllowZoom,
            'overflow-hidden pointer-events-none touch-auto inset-0': !isAllowZoom
          })}
          style={isAllowZoom ? { touchAction: !IS_MOBILE || stableIsMinZoom ? 'pan-y' : 'none' } : undefined}
          {...interactionHandlers}
        >
          {documentHtml && (
            <div className="relative mx-auto bg-white" style={{ width: `${zoomedWidth}px`, height: `${zoomedHeight}px` }}>
              <div
                className="origin-top-left bg-white"
                style={{
                  width: `${A4_WIDTH}px`,
                  height: `${A4_HEIGHT}px`,
                  transform: `scale(${previewScale})`
                }}
                dangerouslySetInnerHTML={{ __html: documentHtml }}
              />
            </div>
          )}
        </div>
      </div>
      {isAllowZoom && !IS_MOBILE && (
        <PreviewZoomController
          zoomScale={zoomScale}
          isMinZoom={isMinZoom}
          isMaxZoom={isMaxZoom}
          onZoomOut={handleZoomOut}
          onZoomIn={handleZoomIn}
          onResetZoom={handleResetZoom}
        />
      )}
    </>
  );
};
